import React from "react";
import { Card } from "antd";
import PropTypes from "prop-types";
import './index.less';

const Widget = ({ title, children, styleName, cover, extra, actions, onclickCallback, item, style, noBorder }) => {

  return (
    <Card
      bordered={!noBorder} title={title} onClick={onclickCallback ? () => onclickCallback(item) : null} actions={actions} cover={cover} className={`gx-card-widget ${styleName}`} extra={extra} style={style}>
      {children}
    </Card>
  )
};

export default Widget;
Widget.defaultProps = {
  styleName: '',
};

Widget.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  cover: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired
};
